import { useInterval } from '@otuvy/ionic-react-common';
import { logFriendlyObject } from '@otuvy/common';
import { syncData } from './sync';
import { EnvironmentConfig, getFlag, getNumber } from '../utils/environmentUtils';
import useCheckOrgGovernors from '../utils/useCheckOrgGovernors';
import useIsAndroidDeviceScanning from '../hooks/useIsAndroidDeviceScanning';
import { updateOrganizationSettingsFromServer } from '../features/settings/orgSettings/organizationSettingsFromServer';

const usePollForChanges = () => {
  const { checkOrgGovernors } = useCheckOrgGovernors();
  const { isScanning } = useIsAndroidDeviceScanning();

  const poll = () => {
    // syncData rethrows pre-sync (network/auth) failures, so on the poller this was an
    // unhandled rejection every interval. Sync self-reports real failures (CC-1864).
    syncData().catch((error) => console.warn('sync failed (polled)', logFriendlyObject(error)));
    //TODO: poll the governors and other things less frequently than the syncing
    checkOrgGovernors();
    if (getFlag(EnvironmentConfig.ORG_SETTINGS)) {
      updateOrganizationSettingsFromServer();
    }
  };

  const syncInterval: number = getNumber(EnvironmentConfig.SYNC_INTERVAL_IN_MS, 30 * 1000);
  useInterval(poll, syncInterval, { isEnabled: !isScanning });
};

export default usePollForChanges;
